import React from 'react'

import ReportFormBtnDynamic from 'components/Forms/ReportPropertyForm'

import { description as descriptionStyles } from './styles'
import { LEGAL_PROPERTY_LEGEND } from './utils'

const Description = ({
  description,
  id,
  property,
  operationType,
  onSubmitReport,
}) => (
  <section className="description">
    <div
      className="content"
      dangerouslySetInnerHTML={{ __html: description }}
    />
    {operationType === 'SELL' && (
      <div className="content">
        <b>{LEGAL_PROPERTY_LEGEND}</b>
      </div>
    )}
    <div className="property-number">
      <p>No. de propiedad: {id}</p>
      <ReportFormBtnDynamic
        isPublicReport
        property={property}
        onSubmitReport={onSubmitReport}
      />
    </div>

    <style jsx>{descriptionStyles}</style>
  </section>
)

export default Description
